import { render, staticRenderFns } from "./BusinessnewsCreate.vue?vue&type=template&id=a5baab76"
import script from "./BusinessnewsCreate.vue?vue&type=script&lang=js"
export * from "./BusinessnewsCreate.vue?vue&type=script&lang=js"
import style0 from "./BusinessnewsCreate.vue?vue&type=style&index=0&id=a5baab76&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports